export default __webpack_public_path__ + "static/media/lmsDomainAndSSL.61ab529e.gif";